import { useEffect } from "react";

import classes from "./SearchIngredientsBar.module.css";

import useInput from "../../../hooks/input_hook";


// component allows user to search for ingredients
const SearchIngredientsBar = (props) => {
  // check characters are valid in search bar
  const isCorrectCharacters = (value) => value.match(/^[a-zA-Z\s]*[a-zA-Z]$/);
  const searchHandler = props.searchHandler;

  const {
    value: searchValue,
    valueChangeHandler: searchChangeHandler,
    inputBlurHandler: searchBlurHandler,
    borderColor: searchBorderColor,
  } = useInput(isCorrectCharacters);


  // do not search unless there are >1 characters in search bar
  useEffect(() => {
    if (searchValue.length > 0) {
      searchHandler(searchValue);
    } 
  },[searchValue, searchHandler]);


  return (
    <input
      type="text"
      id="search"
      className={classes.input}
      value={searchValue}
      onChange={searchChangeHandler}
      onBlur={searchBlurHandler}
      style={{
        borderColor: ` ${searchBorderColor}`,
        backgroundColor: "#FBEEC1",
      }}
    />
  );
};

export default SearchIngredientsBar;
